import { actionCreatorFactory } from 'typescript-fsa';

const actionCreator = actionCreatorFactory();

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface ShipmentDialogActionParam { }

export const ShipmentDialogAction = actionCreator<ShipmentDialogActionParam>(
    'shipmentDialogAction',
);
